import chinies from './images/chinies.jpg';
import Italian from './images/Italian.jpg';
import Indian from './images/Indian.jpg';
import Thai from './images/Thai.jpg';
import Mexican from './images/Mexican.jpg';
import Desserts from './images/Desserts.jpg';

let menudata = [
    {
        id: 1,
        image: chinies,
        tittle: "Chinies",
        bold:'Chinies Noodles :',
        description: ` often collectively referred to as "mein" or "mian" in Mandarin, are a significant and beloved component of Chinese cuisine. These dishes boast a rich history and are deeply embedded in Chinese culinary traditions. Chinese noodles come in a wide variety of shapes, sizes, and textures, each lending a distinct character to the dish.
        Chow Mein: Similar to Lo Mein, but the noodles are often crispy or pan-fried, giving them a delightful crunch. The toppings and sauces can vary, offering a mix of textures and tastes.
        Dan Dan Noodles: Spicy and savory Sichuan-style noodles typically served with minced pork, chili oil, peanuts, and green onions, providing a perfect balance of heat and umami.`
    },
    {
        id: 2,
        image: Italian,
        tittle: "Italian",
        bold:'Italian bruschetta :',
        description: ` Italian bruschetta is a classic and delightful antipasto (appetizer) from Italy, known for its simplicity and bold flavors. It traditionally consists of grilled or toasted slices of rustic bread, typically made from sourdough or ciabatta, rubbed with garlic, drizzled with olive oil, and topped with ripe and juicy diced tomatoes, fresh basil leaves, and a sprinkle of salt and pepper.
        The star of the bruschetta is the tomatoes. They should be ripe and full of flavor, diced into small pieces, and seasoned with a touch of salt and pepper. The addition of fresh basil leaves brings a fragrant and herbaceous element, elevating the overall taste.`
    },
    {
        id: 3,
        image: Indian,
        tittle: "Indian",
        bold:'Indian food :',
        description: ` is renowned for its rich and diverse flavors, aromatic spices, and vibrant colors. The cuisine is a reflection of India's cultural, geographical, and historical diversity, with each region offering its unique specialties.
        Spices and Flavor: Indian cuisine is famous for its skillful use of spices, which give the dishes their distinct and complex flavors. Common spices include cumin, coriander, turmeric, cardamom, cloves, cinnamon, and chili, among others.
        Street Food: Indian street food is a world of its own, offering a wide range of quick and flavorful snacks.`
    },
    {
        id: 4,
        image: Thai,
        tittle: "Thai",
        bold:'Thai cuisine :',
        description: ` is known for its harmonious balance of flavors, aromatic herbs, and vibrant colors. It is a tantalizing fusion of sweet, spicy, sour, and savory tastes, making it a favorite among food enthusiasts worldwide.
        Flavorful Spices and Herbs: Thai dishes are rich in a variety of spices and herbs that contribute to their distinctive taste. Common ingredients include lemongrass, galangal, Thai basil, kaffir lime leaves, cilantro.
        Fragrant Curries:Thai curries are a cornerstone of the cuisine. Red, green, yellow, and Massaman curries are popular variations, each offering a unique blend of flavors, usually featuring coconut milk, curry paste, and various vegetables or meats.`
    },
    {
        id: 5,
        image: Mexican,
        tittle: "Mexican",
        bold:'Mexican cuisine :',
        description: ` is known for its vibrant and diverse flavors, as well as its rich cultural heritage. It is a delightful amalgamation of indigenous Mesoamerican cooking, Spanish influence from colonization, and various other culinary contributions over the centuries.
        Bold and Spicy Flavors: Mexican food is characterized by its bold and intense flavors, often achieved through the use of a wide array of spices, chilies, and herbs. It's not afraid to pack a punch of heat.
        Tortillas and Corn: Corn is a staple ingredient in Mexican cuisine. Corn tortillas are widely used and form the foundation for many dishes like tacos, enchiladas, and quesadillas.`
    },
    {
        id: 6,
        image: Desserts,
        tittle: "Desserts",
        bold:'Desserts :',
        description: ` are the delightful and decadent conclusion to a meal, designed to satisfy your sweet cravings and provide a perfect ending to any dining experience. These delectable treats come in a variety of forms, textures, and flavors, appealing to the sweet tooth in all of us.
        Pastries:Flaky, buttery, and filled with sweet delights, pastries can come in the form of tarts, croissants, éclairs, and more.
        Dessert Bars:Layers of different ingredients stacked together to create scrumptious bars, such as brownies, lemon bars, or cheesecake bars.`
    },
]
export default menudata;